export const APP_STORE_LINKS = {
  android:
    "https://play.google.com/store/apps/details?id=com.app.nextholidays",
  ios: "https://apps.apple.com/us/app/next-holidays/id6749560329",
  website: "https://www.nextholidays.com/",
};

export const STORE_RATING = "4.2/5";

export const DOWNLOAD_APP_FAQ = [
  {
    id: "multiple-tours",
    question: "Can I book multiple tours at a time?",
    answer:
      "Yes, our easy-to-navigate website offers the flexibility to book multiple tours at a time online. Create the first tour by visiting the respective tour page and clicking ‘Book Now’. You’ll be redirected to the ‘Review Order’ page, where you can use the ‘Continue Shopping’ option to return to the tour listing page and make a further selection of tours. Repeat the same procedure until you’ve made all your choices. Now click ‘Proceed to Checkout’ to add pertinent details and subsequently make payment.",
  },
  {
    id: "payment-confirmation",
    question:
      "Upon making the reservation and payment, how will I confirm whether or not it has been received by you?",
    answer:
      "As soon as we receive your payment, you will receive a confirmation email acknowledging your booking is confirmed, and you can download your tickets or voucher from the Booking Admin Panel.",
  },
  {
    id: "cancel-booking",
    question: "How to cancel a booking?",
    answer:
      "We’re sorry that you need to cancel. Get in touch with us—one of our dedicated agents will help you cancel your booking.",
  },
  {
    id: "refund-process",
    question: "What is the refund process?",
    answer:
      "This largely depends on the cancellation policies of your booking. However, some tours are governed by third-party contracts and are liable as per third-party policies. Normally, it may take 7 working days.",
  },
  {
    id: "visa-application",
    question: "How to apply for a VISA?",
    answer:
      "You can apply for a VISA through our website. When you navigate to the VISA application section, you’ll find a form. Fill the form, upload the necessary documents, and voila!",
  },
  {
    id: "change-dates",
    question: "How to change travel dates?",
    answer:
      "It’s possible to make amendments to your travel arrangements. But make sure that you send us an amendment request and get it confirmed well in advance of your travel date. Also, please be informed that amendments will be accepted only in accordance with the respective tour’s terms and conditions.",
  },
];

export function getDownloadAppFaq(isIndia) {
  if (!isIndia) return DOWNLOAD_APP_FAQ;

  return DOWNLOAD_APP_FAQ.filter((item) => item.id !== "visa-application");
}
